import React from "react";
import { observer } from "mobx-react";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import { CategoryItems } from "@features/offer/desktop/offer-menu/components";

import { SportItemButton } from ".";

export const SportItem = observer(function SportItem(props: {
	item: PrematchOfferMenuStore["menu"];
	store: {
		selectedSport: PrematchOfferMenuStore["selectedSport"];
		toggleUpdateProcessing?: PrematchOfferMenuStore["toggleUpdateProcessing"];
	} & Parameters<typeof CategoryItems>[0]["store"];
}) {
	return (
		<li className="nav--tertiary__item">
			<SportItemButton item={props.item} store={props.store} />
			<CategoryItems sport={props.item} store={props.store} />
		</li>
	);
});
